<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="400px">
      <v-card class="grid">
        <v-toolbar elevation="0">
          {{ $t('message.pages.folderSettings.removeTitle') }}
        </v-toolbar>
        <v-card-text class="my-0 py-0">
          <v-row no-gutters align="center" justify="center">
            <v-col
              cols="12"
              v-for="(removingDomain, i) in removingDomains"
              :key="i"
            >
              {{ removingDomain.url }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 py-6">
          <v-row no-gutters justify="center" align="center">
            <v-spacer />
            <v-col>
              <v-btn
                class="mr-2"
                outlined
                color="primary"
                elevation="0"
                @click="handleClose"
              >
                {{ $t('message.pages.folderSettings.keep') }}
              </v-btn>
            </v-col>
            <v-col>
              <v-btn elevation="0" color="error" @click="handleConfirmRemoval">
                {{ $t('message.pages.folderSettings.removeDomains') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ConfirmRemoveDomains',
  components: {},
  data: () => ({
    open: false,
    removingDomains: [],
  }),
  computed: {},
  mounted() {
    this.$root.$on('openConfirmRemoveDomains', (domains) => {
      this.removingDomains = domains
      this.open = true
    })
  },
  watch: {},
  beforeDestroy() {
    this.$root.$off('openConfirmRemoveDomains')
  },
  methods: {
    handleConfirmRemoval() {
      this.$root.$emit('confirmMultipleRemoval')
      this.handleClose()
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
